import type { FunctionalComponent, JSX } from 'preact';

interface Tab {
  href: string;
  label: string;
  icon: JSX.Element;
}

// 시안(.html/*.html) 의 nav.tab-bar 아이콘을 그대로 옮겼다.
const TABS: Tab[] = [
  {
    href: '/',
    label: '홈',
    icon: (
      <>
        <path d="M3 11l9-8 9 8" />
        <path d="M5 10v10a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V10" />
      </>
    ),
  },
  {
    href: '/webzine',
    label: '웹진',
    icon: (
      <>
        <path d="M4 4h13a2 2 0 0 1 2 2v13a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2V4Z" />
        <path d="M7 8h7" />
        <path d="M7 12h7" />
        <path d="M7 16h4" />
      </>
    ),
  },
  {
    href: '/event',
    label: '이벤트',
    icon: (
      <>
        <rect x="3" y="8" width="18" height="13" rx="1" />
        <path d="M3 12h18" />
        <path d="M12 8v13" />
        <path d="M12 8c-1.5-4-6-4-6-1.5S9 8 12 8Z" />
        <path d="M12 8c1.5-4 6-4 6-1.5S15 8 12 8Z" />
      </>
    ),
  },
  {
    href: '/mission',
    label: '미션',
    icon: (
      <>
        <path d="M4 4.5v15" />
        <path d="M4 5h16l-3 5 3 5H4" />
      </>
    ),
  },
  {
    href: '/mypage',
    label: '적립금',
    icon: (
      <>
        <ellipse cx="12" cy="6" rx="7" ry="3" />
        <path d="M5 6v6c0 1.66 3.13 3 7 3s7-1.34 7-3V6" />
        <path d="M5 12v6c0 1.66 3.13 3 7 3s7-1.34 7-3v-6" />
      </>
    ),
  },
];

/** 현재 경로가 탭에 속하는지. '/' 는 정확히 일치할 때만 활성. */
function isActive(tabHref: string, path: string): boolean {
  return tabHref === '/' ? path === '/' : path.startsWith(tabHref);
}

export const TabBar: FunctionalComponent<{ path: string }> = ({ path }) => (
  <nav class="tab-bar">
    {TABS.map((tab) => (
      <a
        key={tab.href}
        href={tab.href}
        class={isActive(tab.href, path) ? 'tab-item active' : 'tab-item'}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          {tab.icon}
        </svg>
        <span>{tab.label}</span>
      </a>
    ))}
  </nav>
);
